export default __webpack_public_path__ + "static/media/home-branding-agency-bg-img-03.199dd6b5.png";